<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useUiStore } from '@/stores/ui.js';
import { useSiteUrl } from '@/composables/useSiteUrl.js';

const ui = useUiStore();
const route = useRoute();
const crumb = computed(() => String(route.meta?.title || route.name || ''));
const siteUrl = useSiteUrl();
</script>

<template>
  <header class="sticky top-0 z-20 bg-(--admin-canvas) border-b border-(--admin-border)">
    <div class="flex items-center gap-4 px-4 sm:px-7 h-[58px]">
      <button
        @click="ui.toggleSidebar"
        class="lg:hidden w-9 h-9 rounded-lg border border-(--admin-border) grid place-items-center text-(--admin-muted) hover:text-(--admin-text)"
        aria-label="Menü"
      >
        <svg class="w-5 h-5" viewBox="0 0 24 24"><path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" /></svg>
      </button>

      <div class="text-[11px] uppercase tracking-[0.14em] font-semibold text-(--admin-muted) truncate">{{ crumb }}</div>

      <div class="flex-1" />

      <a
        :href="siteUrl"
        target="_blank"
        rel="noopener"
        class="flex items-center gap-[7px] h-[34px] px-[13px] text-[13px] font-medium text-(--admin-accent) bg-white border border-(--admin-border) rounded-lg hover:border-(--admin-accent) transition-colors"
      >
        <svg class="w-3.5 h-3.5" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 3H3v10h3.5M10 5.5 13 8l-3 2.5M6 8h7" /></svg>
        Siteyi Görüntüle
      </a>
    </div>
  </header>
</template>
